<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <b-tabs content-class="mt-3">
          <b-tab title="Receive Device" active>
            <form-base
              :submit-status="submitStatus"
              action="Received"
              :errors="errors"
              :loading="loading"
              v-on:handleSubmit="handleSubmit"
            >
              <template v-slot:fields>
                <h3 v-if="job.job_shippings && job.job_shippings.length > 0">
                  {{ job.job_shippings[0].courier.name }}
                </h3>

                  
                 <div class="border p-2 my-2">
                  <div class="row">
                    <div class="col-auto">
                      <span class="bg-primary text-white px-3 font-size-26">
                        {{ job.job_number }}</span
                      >
                    </div>
                    <div class="col">
                      <p class="text-muted mt-2 mb-0" v-if="job.manufacture">
                        {{ job.manufacture.description }} -
                        {{ job.device_type.description }}
                        <span v-if="job.device_model">
                          <br />
                          <strong>{{ job.device_model.code }}</strong> -
                          {{ job.imei_in ? job.imei_in : job.serial_in }}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>


                <hr v-if="job.job_shippings && job.job_shippings.length > 0" />

                  <form-group label="IMEI #">
              <input type="text" class="form-control" v-model="job.imei_in" />
              <small v-if="$v.job.imei_in.$error" class="text-danger">
                Please enter IMEI or a SERIAL# (IMEI Should be 15 Characters)
              </small>
           
            </form-group>

            <form-group label="Serial #">
              <input type="text" class="form-control" v-model="job.serial_in" />
              <small v-if="$v.job.serial_in.$error" class="text-danger">
                Please enter IMEI or Serial #
              </small>
            </form-group>

                <form-group label="Device Type" :required="true">
                  <b-skeleton type="input" v-show="loading"></b-skeleton>
                  <v-select
                    label="description"
                    @input="clearModel"
                    :reduce="(deviceType) => deviceType.id"
                    :options="deviceTypes"
                    v-show="!loading"
                    v-model="job.device_type_id"
                  >
                    <template slot="option" slot-scope="dt">
                      <div>{{ dt.code }} - {{ dt.description }}</div>
                    </template>
                    <template slot="selected-option" slot-scope="dt">
                      {{ dt.description }}
                    </template>
                  </v-select>
                  <small
                    v-if="$v.job.device_type_id.$error"
                    class="text-danger"
                  >
                    Please select type
                  </small>
                </form-group>

                <form-group label="Manufacture" :required="true">
                  <b-skeleton type="input" v-show="loading"></b-skeleton>
                  <v-select
                    label="description"
                    @input="clearModel"
                    :reduce="(manufacture) => manufacture.id"
                    :options="manufactures"
                    v-show="!loading"
                    v-model="job.manufacture_id"
                  >
                    <template slot="option" slot-scope="man">
                      <div>{{ man.code }} - {{ man.description }}</div>
                    </template>
                    <template slot="selected-option" slot-scope="man">
                      {{ man.description }}
                    </template>
                  </v-select>
                  <small
                    v-if="$v.job.manufacture_id.$error"
                    class="text-danger"
                  >
                    Please select manufacture
                  </small>
                </form-group>

                <form-group
                  :required="true"
                  label="Model"
                  v-if="job.manufacture_id && job.device_type_id"
                >
                  <b-skeleton type="input" v-show="loading"></b-skeleton>
                  <v-select
                    label="description"
                    :reduce="(deviceModel) => deviceModel.id"
                    :options="
                      deviceModels.filter(
                        (m) =>
                          m.manufacture_id == job.manufacture_id &&
                          m.device_type_id == job.device_type_id
                      )
                    "
                    v-show="!loading"
                    v-model="job.device_model_id"
                  >
                    <template slot="option" slot-scope="mod">
                      <div>{{ mod.code }} - {{ mod.description }}</div>
                    </template>
                    <template slot="selected-option" slot-scope="mod">
                      {{ mod.description }}
                    </template>
                  </v-select>
                  <small
                    v-if="$v.job.device_model_id.$error"
                    class="text-danger"
                  >
                    Please select model
                  </small>
                </form-group>

                <form-group label="Condition Description">
                  <textarea
                    class="form-control"
                    v-model="job.condition_description"
                  />
                </form-group>

                <form-group label="Device Condition">
                  <b-form-checkbox-group
                    v-model="job.device_conditions"
                    :options="deviceConditions.filter(
                    (m) =>
                      m.device_type_id == job.device_type_id
                  )"
                    value-field="id"
                    text-field="description"
                    switches
                    stacked
                  ></b-form-checkbox-group>
                </form-group>

                <form-group label="Device Accessories">
                  <b-form-checkbox-group
                    v-model="job.device_accessories"
                    :options="deviceAccessories.filter(
                    (m) =>
                      m.device_type_id == job.device_type_id
                  )"
                    value-field="id"
                    text-field="description"
                    switches
                    stacked
                  ></b-form-checkbox-group>
                </form-group>

                <form-group label="Images">
                  <image-upload
                    @files-uploaded="
                      selectedDeviceImages = $event;
                      imageUploading = false;
                    "
                    @files-uploaded-started="imageUploading = true"
                    :multiple="true"
                    :imageCrop="false"
                    acceptedTypes="image/*"
                  />
                </form-group>
              </template>
            </form-base>
          </b-tab>

          <b-tab title="Client" v-if="job.client_id">
            <client :id="job.client_id" class="mt-3"></client>
          </b-tab>

          <b-tab v-if="job.partner_id" title="Partner">
            <partner :id="job.partner_id" class="mt-3"></partner>
          </b-tab>

          <b-tab title="Job">
            <job-minimal :id="id"></job-minimal>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import shippingRepo from "@/api/repos/shippingRepo";
import { required,requiredIf,maxLength,minLength } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";
import partner from "@/views/modules/partners/show";
import client from "@/views/modules/clients/show";
import jobMinimal from "@/views/modules/jobs/enquiryMinimal";
import imageUpload from "@/components/common/ImageUpload";

export default {
  components: {
    formBase,
    formGroup,
    partner,
    client,
    jobMinimal,
    imageUpload,
  },

  props: ["id"],

  mounted() {
    this.getCreatedData(this.id);
  },

  data() {
    return {
      manufactures: [],
      deviceTypes: [],
      deviceModels: [],
      deviceConditions: [],
      deviceAccessories: [],
      shipping: {},
      job: {},
      loading: false,
      errors: null,
      submitStatus: null,
      imageUploading: false,
      selectedDeviceConditons: [],
      selectedDeviceAccessories: [],
      selectedDeviceImages: [],
    };
  },

  validations: {
    job: {
      imei_in: {
        required: requiredIf(function (job) {
          return job.serial_in == null;
        }),
        minLength:minLength(15),
        maxLength:maxLength(15)
      },
      serial_in: {
        required: requiredIf(function (job) {
          return job.imei_in == null;
        }),
      },
      device_type_id: {
        required,
      },
      manufacture_id: {
        required,
      },
      device_model_id: {
        required,
      },
    },
  },

  methods: {
    async getCreatedData(id) {
      try {
        this.loading = true;
        let { data } = await shippingRepo.inboundReceivedCreate(id);
        this.deviceConditions = data.device_conditions;
        this.deviceAccessories = data.device_accessories;
        this.job = data.job;
        this.deviceModels = data.device_models;
        this.manufactures = data.manufactures;
        this.deviceTypes = data.device_types;
        this.job.device_conditions = data.job.device_conditions.map(
          (x) => x.id
        );
        this.job.device_accessories = data.job.device_accessories.map(
          (x) => x.id
        );
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    clearModel() {
      if (this.job.device_model_id != null) {
        this.job.device_model_id = null;
      }
    },
    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
          if (this.selectedDeviceImages.length > 0) {
            this.job.job_images = this.selectedDeviceImages.split(",");
          }
          await shippingRepo.inboundReceivedStore(this.job);
          this.$emit("receivedCreated");
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
  },
};
</script>

